import { gsap } from 'gsap';
import Observer from '../classes/Observer';

class Marquee extends Observer {
  $el: JQuery<HTMLElement>;
  width: number;
  speed: number;
  animation!: gsap.core.Tween;

  constructor(el: HTMLElement) {
    super({
      isOnce: false
    });
    this.$el = $(el);
    this.width = this.$el.width()!;
    this.speed = this.width / 500;

    if(!this.$el.length || !this.observer) return;

    this.animation = gsap.fromTo(this.$el.get(0)!, {
      x: '-3.125%',
    }, {
      x: '-15.625%', // -12.5% - 3.125%%
      duration: this.speed,
      paused: true,
      ease: 'none',
      repeat: -1,
    });

    this.observer.observe(this.$el.get(0)!);
  }

  animateIn() {
    this.animation.play();
  }

  animateOut() {
    this.animation.pause();
  }
}

export default Marquee;
